import { render, staticRenderFns } from "./main-message.vue?vue&type=template&id=5e59b5c4"
import script from "./main-message.vue?vue&type=script&lang=js"
export * from "./main-message.vue?vue&type=script&lang=js"
import style0 from "./main-message.vue?vue&type=style&index=0&id=5e59b5c4&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports